import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Persists the child social-icon block comments only. Frontend markup is
 * produced server-side by render.php (the parent is the sole frontend
 * renderer, via render_callback + skip_inner_blocks).
 *
 * This MUST NOT return null. A save() that returns null makes Gutenberg
 * serialize the block as a self-closing `<!-- wp:brandy/social-icons /-->`
 * and DISCARD every inner block: children — and any URLs typed into them —
 * vanish on save. `<InnerBlocks.Content />` emits no markup of its own, so the
 * server still owns rendering; it exists purely to write the child comments
 * back out. Avatar Group does the same thing for the same reason.
 */
export default function Save() {
  return <InnerBlocks.Content />;
}
